import { type AnyRoute, createRoute } from "@tanstack/react-router";
import { lazy } from "react";

// Lazily loaded — the marketplace (grid, editor, detail) isn't needed on the
// default /chat landing, so it ships as its own chunk.
const AssistantsPage = lazy(() =>
  import("../components/AssistantsPage").then((m) => ({ default: m.AssistantsPage })),
);
const AssistantDetailPage = lazy(() =>
  import("../components/AssistantDetailPage").then((m) => ({ default: m.AssistantDetailPage })),
);

/** Assistants routes — the explore grid and a per-assistant detail view. */
export function createAssistantsRoutes<TParent extends AnyRoute>(parent: TParent) {
  const list = createRoute({
    getParentRoute: () => parent,
    path: "/assistants",
    component: AssistantsPage,
  });
  const detail = createRoute({
    getParentRoute: () => parent,
    path: "/assistants/$id",
    component: AssistantDetailPage,
  });
  return [list, detail];
}
